<div class="row row-20 return-process" id="leftCont-rightNav">
    <section class="col-xs-12 col-sm-12 col-md-12 left-section" style="min-height: 165px;">
        <div class="content">
            <p class="guide">We'll guide you through the returns process for expired vaccines in just three steps.</p>
            <div class="col-xs-12 col-sm-12 col-md-12 p0 steps step-1">
                <h2 class="step-title"><img src="../../../assets/img/print-white.svg" alt="Print">STEP 1</h2>
                <h3 class="return-heading">Complete the returns form</h3>
                <div class="col-xs-12 col-sm-12 col-md-12 p0 step-secondary">
                    <div class="col-xs-12 col-sm-12 p0">
                        <h4>Returning expired vaccines?</h4>
                        <p>To get started, download the Return Goods Information form below. Then complete and save the
                            form for use in step 2. Returns are accepted for expired vaccines only.<sup
                                style="color:#347ab7">1</sup> </p>
                                <!-- <a
                            href="/us/_ui/responsive/theme-lambda/pdf/SanofiPasteurExpiredReturnsGoodForm(Interactive).pdf"
                            download="" class="sanofi-download-icon" target="_blank"
                            data-di-id="di-id-c37c1217-148e3a04"><img src="../../../assets/img/download.svg"
                                alt="Download">Download Return Goods Information (RGI) Form</a> -->
                                <!--download attribute not working.opening file in browser only-->
                                <a [href]="downloadRGIForm" download="SanofiPasteurExpiredReturnsGoodForm(Interactive).pdf" target="_blank"
                                class="sanofi-download-icon"><img src="../../../assets/img/download.svg"
                                    alt="Download">Download Return Goods Information (RGI) Form</a>
                    </div>
                    <div class="col-xs-12 col-sm-12 p0">
                        <h4>Returning expired influenza vaccines?</h4>
                        <p>Start by logging in and generating your influenza return form in the influenza returns
                            section. Then save the form for use in step 2. Returns are accepted for expired vaccines
                            only.<sup style="color:#347ab7">1</sup> </p><a class="sanofi-download-icon"
                            href="javascript:void(0)" (click)="navigateToReturnPage()" target="_blank"
                            data-di-id="di-id-a148f2ec-d5996620">Go to influenza returns</a>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 p0 steps step-2">
                <h2 class="step-title"><img src="../../../assets/img/edit-white.svg" alt="Edit">STEP 2</h2>
                <h3 class="return-heading">Generate your returns authorization</h3>
                <div class="col-xs-12 col-sm-8 col-md-12 p0 step-secondary">
                    <div class="col-xs-12 col-sm-12 p0">
                        <p>Log in to our returns partner, 
                            <!-- <a title="" data-target="#request-ret" data-toggle="modal"> -->
                            <a (click)="openPopup('https://hrm.reskureturns.com/landing')">
                                Inmar Healthcare Returns Management Portal<img
                                    src="../../../assets/img/external-link.png" alt="Edit"></a>. Then provide the
                            requested information and upload your completed form from step 1. You'll leave
                            VaccineShop.com for this step.</p><a title="" data-target="#request-ret"
                            data-toggle="modal">
                            <button (click)="openPopup('https://hrm.reskureturns.com/landing')" class="btn btn-default footerMyacc-btn">Log-in to Inmar <img
                                    src="../../../assets/img/external-link.png" alt="Login"></button> </a>
                        <p>Need step-by-step instructions for registering with Inmar or generating your returns
                            authorization? Download our returns process reference guide below.</p>
                            <!-- <a href="/us/_ui/responsive/theme-lambda/pdf/ReturnsReferenceGuide2020.pdf" download="" -->
                                <a [href]="downloadrefGuide" download="ReturnsReferenceGuide.pdf"
                            class="sanofi-download-icon" target="_blank" data-di-id="di-id-10481410-33ddd0e5"><img
                                src="../../../assets/img/download.svg" alt="Download">Download Returns Process Reference
                            Guide</a>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 p0 steps step-3">
                <h2 class="step-title"><img src="../../../assets/img/print-white.svg" alt="Shipment">STEP 3</h2>
                <h3 class="return-heading">Ship your expired vaccines</h3>
                <div class="col-xs-12 col-sm-8 col-md-12 p0 step-secondary">
                    <div class="col-xs-12 col-sm-12 p0">
                        <p>Once you've generated your returns authorization, ship your return. Your return should
                            include:</p>
                        <ul>
                            <li>The expired vaccines you're returning (there's no need to refrigerate them)</li>
                            <li>Your completed Return Goods Information form, placed <strong>inside</strong> the package
                            </li>
                            <li>Your returns authorization, attached to the <strong>outside</strong> of the box (note
                                that this is <strong>not</strong> a shipping label)</li>
                            <li>A prepaid shipping label </li>
                        </ul>
                        <h4>Address your shipment to:</h4>
                        <p class="address">Inmar RX Solutions, Inc.<br>3845 Grand Lakes Way, Suite 125<br>Grand Prairie,
                            TX 75050</p>
                            <a [href]="downloadrefGuide" download="ReturnsReferenceGuide.pdf"
                            class="sanofi-download-icon" target="_blank"
                            data-di-id="di-id-10481410-33ddd0e5"><img src="../../../assets//img/download.svg"
                                alt="Download">Download
                            Returns Process Reference Guide</a>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 p0 terms-condition">
                <p><sup style="color:#347ab7">1</sup>Sanofi Pasteur offers 100% credit upon expiration on Sanofi Pasteur
                    product(s) purchased directly from Sanofi Pasteur that are returned within 1 year after the
                    expiration date. The Return Goods Policy is subject to change without prior notification. The Return
                    Goods Policy does not provide any return rights for Imogam Rabies-HT, Rabies Immune Globulin (Human)
                    USP, Heat Treated, or YF-VAX Yellow Fever Vaccine, or any of the Fluzone Influenza Vaccines and
                    Flublok Influenza Vaccine, except for certain contractual, promotional, and program exceptions.</p>
                <p>Please visit our 
                    <!-- <a href="/us/misc/termsandconditions" target="_blank" data-di-id="di-id-f9f206c7-ac70112d">  -->
                    <a [href]="downloadTnC" target="_blank" download="SanofiReturnsTnC.pdf">
                        Terms &amp; Conditions</a> page for additional information
                    on our returns policy.</p>
            </div>
        </div>

        <!--Using shared popup-->
        <!-- <div id="request-ret" class="modal popup-comp ao-popup" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">You are about to leave a Sanofi website.</h4>
                    </div>
                    <div class="modal-body">
                        Sanofi does not review the information contained on this website and/or database for content,
                        accuracy or completeness. Use of and access to this information is subject to the terms,
                        limitations and conditions set by the website and/or database producer. Sanofi makes no
                        representation as to the accuracy or any other aspect of the information contained on such
                        website and/or database, nor does Sanofi necessarily endorse such website and/or database.
                    </div>
                    <div class="modal-footer">
                        <a href="https://returns.healthcare.inmar.com/" title="" target="_blank"
                            data-di-id="di-id-7b860682-258a2c18"> <button type="button"
                                class="btn btn-default blue-button loc-dn">Proceed</button></a>
                        <button type="button" data-dismiss="modal"
                            class="btn btn-default white-button mt2 btn-cancel">Cancel</button>
                    </div>
                </div>
            </div>
        </div> -->
    </section>
</div>